/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The method used to install the cloud role
*/
export enum AccountInstallationMethod {
  ACCOUNT_INSTALLATION_METHOD_UNSPECIFIED = 'UNSPECIFIED',
  ACCOUNT_INSTALLATION_METHOD_CLOUDFORMATION = 'CLOUDFORMATION',
  ACCOUNT_INSTALLATION_METHOD_TERRAFORM = 'TERRAFORM',
  ACCOUNT_INSTALLATION_METHOD_BASH_SCRIPT = 'BASH_SCRIPT'
}
